////////// Helpers
Date.today = function () {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
};

Date.tomorrow = function () {
  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  return tomorrow;
}; ////////// Calculations


Object.defineProperty(Date.prototype, 'intervalUntilNow', {
  get: function intervalUntilNow() {
    var now = new Date();
    return this.getTime() - now.getTime();
  }
});
Object.defineProperty(Date.prototype, 'hasPassed', {
  get: function hasPassed() {
    var now = new Date();
    return this <= now;
  }
});
Object.defineProperty(Date.prototype, 'isToday', {
  get: function isToday() {
    var now = new Date();
    return this.getDate() === now.getDate() && this.getMonth() === now.getMonth() && this.getFullYear() === now.getFullYear();
  }
}); // ISO Formats

Date.prototype.toISODateString = function () {
  var year = this.getFullYear().toString().padStart(4, '0');
  var month = (this.getMonth() + 1).toString().padStart(2, '0');
  var day = this.getDate().toString().padStart(2, '0');
  return "".concat(year, "-").concat(month, "-").concat(day);
};

Date.prototype.toISOMonthString = function () {
  var year = this.getFullYear().toString().padStart(4, '0');
  var month = (this.getMonth() + 1).toString().padStart(2, '0');
  return "".concat(year, "-").concat(month);
}; // Relative


Date.prototype.toRelativeString = function () {
  var difference = this.intervalUntilNow / 1000;
  var past = difference <= 0;
  difference = Math.abs(difference);

  if (this.isToday) {
    var content = '';

    if (difference < 90) {
      content = '1 minute';
    } else if (difference < 3600) {
      var minutes = Math.round(difference / 60);
      content = "".concat(minutes, " minutes");
    } else if (difference < 5400) {
      // 1.5 hours
      content = '1 hour';
    } else {
      var hours = Math.round(difference / 3600);
      content = "".concat(hours, " hours");
    }

    if (past) {
      return "".concat(content, " ago");
    } else {
      return "in ".concat(content);
    }
  } else {
    if (difference < 604800) {
      // 7 days
      return this.weekdayName;
    } else {
      return this.toLocaleDateString();
    }
  }
};

Date.prototype.toRelativeShortString = function () {
  var difference = this.intervalUntilNow / 1000;
  var past = difference <= 0;
  var sign = past ? '-' : '';
  difference = Math.abs(difference);

  if (this.isToday) {
    if (difference < 90) {
      var seconds = Math.round(difference);
      return "".concat(sign).concat(seconds, "s");
    } else if (difference < 3600) {
      var minutes = Math.round(difference / 60);
      return "".concat(sign).concat(minutes, "m");
    } else {
      var hours = Math.round(difference / 3600);
      return "".concat(sign).concat(hours, "h");
    }
  } else {
    if (difference < 604800) {
      // 7 days
      return this.shortWeekdayName;
    } else {
      return this.toShortDateString();
    }
  }
}; ////////// Names


var WEEKDAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
Object.defineProperty(Date.prototype, 'weekdayName', {
  get: function weekdayName() {
    return WEEKDAY_NAMES[this.getDay()];
  }
});
var SHORT_WEEKDAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
Object.defineProperty(Date.prototype, 'shortWeekdayName', {
  get: function weekdayName() {
    return SHORT_WEEKDAY_NAMES[this.getDay()];
  }
});
var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
Object.defineProperty(Date.prototype, 'monthName', {
  get: function monthName() {
    return MONTH_NAMES[this.getMonth()];
  }
});